import { createRouter, createWebHashHistory } from 'vue-router';
import { useRouterStore } from '@/stores/router';

// 控制中心
import NavControl from '../views/Navgation/NavControl.vue';
// 首页
import HomePage from '../views/Home/HomePage.vue';
// 产品功能
import ProductAbility from '../views/Product/ProductAbility.vue';
import FuncDetail from '../views/Product/FuncDetail.vue';
import FuncList from '../views/Product/FuncList.vue';
// 开发者文档
import DevDocsCenter from '../views/DevDocs/DevDocsCenter.vue';
import ServiceApi from '../views/DevDocs/ServiceApi.vue';
import JavaScriptApi from '../views/DevDocs/JavaScriptApi.vue';
import AndroidApi from '../views/DevDocs/AndroidApi.vue';
import IOSApi from '../views/DevDocs/IOSApi.vue';
import StreamingApi from '../views/DevDocs/StreamingApi.vue';
import DevGuide from '../views/DevDocs/DevGuide.vue';
import DevCourse from '../views/DevDocs/DevCourse.vue';
import ToolUseGuide from '../views/DevDocs/ToolUseGuide.vue';
// Demo
import WebDemo from '../views/Demo/WebDemo.vue';
// 搜索中心
import SearchCenter from '../views/Search/SearchCenter.vue';
// FAQ
import FAQMsg from '../views/FAQ/FAQMsg.vue';
// 下载与更新
import DownloadUpdate from '../views/Update/DownloadUpdate.vue';
// 黑洞生态
import BlockHoleEcology from '../views/Ecology/BlockHoleEcology.vue';
// 联系我们
import ContactUs from '../views/Contact/ContactUs.vue';
// 消息中心
import MsgCenter from '../views/Message/MsgCenter.vue';
// PDF
import PDFViewer from '../views/PDF/PDFViewer.vue';

var router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: '/index',
        },
        {
            path: '/docs',
            redirect: '/docs-center',
        },
        {
            path: '/index',
            component: NavControl,
            children: [
                {
                    path: '/home',
                    component: HomePage,
                },
                {
                    path: '/product-ability',
                    component: ProductAbility,
                },
                {
                    path: '/product-ability/func-detail',
                    component: FuncDetail,
                },
                {
                    path: '/product-ability/func-list',
                    component: FuncList,
                },
                {
                    path: '/docs-center',
                    component: DevDocsCenter,
                },
                {
                    path: '/docs/service-api',
                    component: ServiceApi,
                },
                {
                    path: '/docs/js-api',
                    component: JavaScriptApi,
                },
                {
                    path: '/docs/android-api',
                    component: AndroidApi,
                },
                {
                    path: '/docs/ios-api',
                    component: IOSApi,
                },
                {
                    path: '/docs/streaming-api',
                    component: StreamingApi,
                },
                {
                    path: '/docs/guide',
                    component: DevGuide,
                },
                {
                    path: '/docs/course',
                    component: DevCourse,
                },
                {
                    path: '/docs/tool-use-guide',
                    component: ToolUseGuide,
                },
                {
                    path: '/docs/web-demo',
                    component: WebDemo,
                },
                {
                    path: '/docs/faq',
                    component: FAQMsg,
                },
                {
                    path: '/developer-updates',
                    component: DownloadUpdate,
                },
                {
                    path: '/search-center',
                    component: SearchCenter,
                },
                {
                    path: '/msg-center',
                    component: MsgCenter,
                },
                {
                    path: '/ecology',
                    component: BlockHoleEcology,
                },
                {
                    path: '/contact',
                    component: ContactUs,
                },
            ],
        },
        {
            path: '/pdfviewer',
            component: PDFViewer,
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        // 在路由元信息中记录滚动位置
        if (savedPosition) {
            from.meta.savedPosition = savedPosition;
        }
    },
});

// 添加路由位置追踪逻辑
let isBack = false;
router.beforeEach((to, from, next) => {
    // 获取当前路由栈位置
    const currentPosition = window.history.state.position;

    // 首次访问时初始化位置
    if (typeof from.meta.position === 'undefined') {
        from.meta.position = currentPosition;
    }

    // 判断是否为后退操作
    if (currentPosition < from.meta.position) {
        isBack = true;
        // console.log('检测到浏览器后退操作', {
        //     from: from.path,
        //     to: to.path,
        //     position: currentPosition,
        // });
        // 在此处添加你的处理逻辑
    } else {
        isBack = false;
    }

    // 更新路由位置记录
    to.meta.position = currentPosition;
    next();
});

// 添加全局后置钩子验证
router.afterEach((to, from) => {
    if (isBack) {
        // console.log('确认后退操作完成', to.fullPath);
        // 可以在这里执行需要延迟处理的后退逻辑
    }
    const router_store = useRouterStore();
    router_store.pathChange(to, from);
});

export default router;
